// PatisserieFields.jsx
import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const PatisserieFields = ({
  item,
  updateItem,
  patisserieItems,
  isStandardDesign,
  setIsStandardDesign,
}) => {
  const getAvailablePatisserieFlavors = () => {
    return patisserieItems
      .filter((p) => p.subcategory === item.type)
      .map((p) => ({
        name: p.name,
        displayName: p.displayName,
        flavor: p.flavor || null,
        label: p.flavor || p.displayName,
        image: p.images?.regularOrderImage,
        price: p.orderConfig?.regular?.price,
      }));
  };

  const handleFlavorChange = (e) => {
    const selected = getAvailablePatisserieFlavors().find(
      (f) => f.label === e.target.value
    );

    if (selected) {
      const updates = {
        flavor: {
          name: selected.name,
          displayName: selected.label,
        },
        unitPrice: selected.price,
      };

      if (isStandardDesign) {
        updates.image = selected.image;
      }

      updateItem(item._id, updates);
    }
  };

  const handleDesignChange = (e) => {
    const isStandard = e.target.value === "standard";
    setIsStandardDesign(isStandard);

    if (isStandard && item.flavor?.name) {
      const selected = getAvailablePatisserieFlavors().find(
        (f) =>
          f.flavor === item.flavor.name ||
          f.label === item.flavor.displayName ||
          f.displayName === item.flavor.displayName
      );

      if (selected?.image) {
        updateItem(item._id, { image: selected.image });
      }
    } else {
      updateItem(item._id, { image: "" });
    }
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Flavor"
          fullWidth
          value={item.flavor?.label || item.flavor?.displayName || ""}
          onChange={handleFlavorChange}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 300,
                  overflowY: "auto",
                },
              },
            },
          }}>
          <MenuItem value="">
            <em>Select a flavor</em>
          </MenuItem>
          {getAvailablePatisserieFlavors().map((flavor) => (
            <MenuItem key={flavor.name} value={flavor.label}>
              {flavor.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Design Type"
          fullWidth
          value={isStandardDesign ? "standard" : "custom"}
          onChange={handleDesignChange}>
          <MenuItem value="standard">Standard Design</MenuItem>
          <MenuItem value="custom">Custom Design</MenuItem>
        </TextField>
      </Grid>
    </>
  );
};

export default PatisserieFields;
